import 'dayjs/locale/ko'

const ko = {
  calendar: {
    sameDay: '오늘 LT',
    nextDay: '내일 LT',
    lastDay: '어제 LT',
    sameElse: 'L'
  }
}

export default ko
